import React from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { Btn } from "@/components/kmt/ui";
import { downloadFile, errMsg, useLoad, useOwnerApi } from "@/lib/api";
import { ct, prettyPhone } from "@/lib/format";
import { PageTitle } from "./DashLayout";

export default function Agreements() {
  const api = useOwnerApi();
  const { data, error } = useLoad(() => api.get("/agreements").then((r) => r.data), [api]);
  const dl = async (a: any) => {
    try {
      const r = await downloadFile(api, `/agreements/${a.id}/pdf`, `KMT-Agreement-${a.phone}.pdf`);
      if (r.headers["x-integrity"] === "mismatch") toast.error("Warning: file fingerprint does not match the audit record");
      else toast.success("Fingerprint verified");
    } catch (e) { toast.error(errMsg(e)); }
  };
  if (error) return <p className="text-red-200">{error}</p>;
  return (
    <div>
      <PageTitle title="Master Agreements" sub={data ? `Current version: ${data.current_version}` : ""} />
      <div className="overflow-x-auto rounded-md border border-gold/20">
        <table className="w-full min-w-[860px] text-left text-[15px]" data-testid="agreements-table">
          <thead className="bg-aubergine text-[14px] text-gold">
            <tr><th className="p-4 font-medium">Customer</th><th className="p-4 font-medium">Version</th><th className="p-4 font-medium">Status</th><th className="p-4 font-medium">Signed</th><th className="p-4 font-medium">Audit</th><th className="p-4" /></tr>
          </thead>
          <tbody className="divide-y divide-gold/10">
            {(data?.agreements || []).map((a: any) => (
              <tr key={a.id}>
                <td className="p-4">{a.name}<br /><span className="text-[14px] text-mist/65">{prettyPhone(a.phone)}</span></td>
                <td className="p-4">{a.version}{a.version !== data.current_version && <span className="block text-[14px] text-amber-200">Old version</span>}</td>
                <td className="p-4" data-testid={`agreement-status-${a.id}`}>{a.status === "pending" && new Date(a.expires_at) < new Date() ? "expired" : a.status}</td>
                <td className="p-4">{a.signed ? <>{a.signed.full_name}<br /><span className="text-[14px] text-mist/65">{ct(a.signed.signed_at)}</span></> : "—"}</td>
                <td className="p-4 text-[14px] text-mist/70">{a.signed ? <>IP {a.signed.ip}<br />SHA-256 {a.signed.sha256.slice(0, 16)}…</> : "—"}</td>
                <td className="p-4">{a.signed && <Btn variant="ghost" onClick={() => dl(a)} data-testid={`agreement-download-${a.id}`}><Download size={18} /> PDF</Btn>}</td>
              </tr>
            ))}
            {data && !data.agreements.length && <tr><td colSpan={6} className="p-6 text-mist/60">No agreements yet. Create a signing link from a booking or customer.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
